import { getURLParam } from './util';

/**
 * Plugin for search form.
 */
(function ($) {
	var searchForm;

	var init = function () {
		searchForm.find('.filter-type').prop('disabled', false);
		searchForm.find('.search-form-item').each(function () {
			createFilterInput($(this));
		});
		searchForm.submit(validate);

		attachHandlers(searchForm);
		showFormTools();
		invalidateFilterOptions();
		trueFalseToggles();
	};

	/**
	 * True / false filters have AND between them, there are some logical choices that aren't logical
	 */
	var trueFalseToggles = function () {
		// Outages
		$(document).on('change', '#tf-is-available', function () {
			if ($(this).is(':checked')) {
				$('#tf-has-outage').prop('checked', false);
				$('#tf-planned-outage').prop('checked', false);
				$('#tf-cancelled').prop('checked', false);
				$('#tf-planned-start').prop('checked', false);
			}
		});

		$(document).on('change', '#tf-has-outage', function () {
			if ($(this).is(':checked')) {
				$('#tf-is-available').prop('checked', false);
				$('#tf-planned-outage').prop('checked', false);
				$('#tf-cancelled').prop('checked', false);
				$('#tf-planned-start').prop('checked', false);
			}
		});

		$(document).on('change', '#tf-planned-outage', function () {
			if ($(this).is(':checked')) {
				$('#tf-is-available').prop('checked', false);
				$('#tf-has-outage').prop('checked', false);
				$('#tf-cancelled').prop('checked', false);
				$('#tf-planned-start').prop('checked', false);
			}
		});

		$(document).on('change', '#tf-cancelled', function () {
			if ($(this).is(':checked')) {
				$('#tf-is-available').prop('checked', false);
				$('#tf-has-outage').prop('checked', false);
				$('#tf-planned-outage').prop('checked', false);
				$('#tf-planned-start').prop('checked', false);
			}
		});

		$(document).on('change', '#tf-planned-start', function () {
			if ($(this).is(':checked')) {
				$('#tf-is-available').prop('checked', false);
				$('#tf-has-outage').prop('checked', false);
				$('#tf-planned-outage').prop('checked', false);
				$('#tf-cancelled').prop('checked', false);
			}
		});

		// Reimbursed / not
		$(document).on('change', '#tf-reimbursed', function () {
			if ($(this).is(':checked')) {
				$('#tf-not-reimbursed').prop('checked', false);
			}
		});

		$(document).on('change', '#tf-not-reimbursed', function () {
			if ($(this).is(':checked')) {
				$('#tf-reimbursed').prop('checked', false);
			}
		});

		// Limited availability / Safety stock
		$(document).on('change', '#tf-limited-availability', function () {
			if ($(this).is(':checked')) {
				$('#tf-reserve-stock-system').prop('checked', false);
			}
		});

		$(document).on('change', '#tf-reserve-stock-system', function () {
			if ($(this).is(':checked')) {
				$('#tf-limited-availability').prop('checked', false);
			}
		});

		// SCAU
		$(document).on('change', '#tf-change-in-price-list', function () {
			if ($(this).is(':checked')) {
				$('#tf-new-in-price-list').prop('checked', false);
				$('#tf-deleted-from-price-list').prop('checked', false);
			}
		});

		$(document).on('change', '#tf-new-in-price-list', function () {
			if ($(this).is(':checked')) {
				$('#tf-change-in-price-list').prop('checked', false);
				$('#tf-deleted-from-price-list').prop('checked', false);
				$('#tf-change-in-indication').prop('checked', false);
			}
		});

		$(document).on('change', '#tf-deleted-from-price-list', function () {
			if ($(this).is(':checked')) {
				$('#tf-change-in-price-list').prop('checked', false);
				$('#tf-new-in-price-list').prop('checked', false);
				$('#tf-change-in-indication').prop('checked', false);
			}
		});

		$(document).on('change', '#tf-change-in-indication', function () {
			if ($(this).is(':checked')) {
				$('#tf-new-in-price-list').prop('checked', false);
				$('#tf-deleted-from-price-list').prop('checked', false);
			}
		});

		// Proposed SCAU
		$(document).on('change', '#tf-proposed-change-in-price-list', function () {
			if ($(this).is(':checked')) {
				$('#tf-proposed-new-in-price-list').prop('checked', false);
				$('#tf-proposed-deleted-from-price-list').prop('checked', false);
			}
		});

		$(document).on('change', '#tf-proposed-new-in-price-list', function () {
			if ($(this).is(':checked')) {
				$('#tf-proposed-change-in-price-list').prop('checked', false);
				$('#tf-proposed-deleted-from-price-list').prop('checked', false);
			}
		});

		$(document).on('change', '#tf-proposed-deleted-from-price-list', function () {
			if ($(this).is(':checked')) {
				$('#tf-proposed-change-in-price-list').prop('checked', false);
				$('#tf-proposed-new-in-price-list').prop('checked', false);
			}
		});
	};

	var destroy = function () {
		searchForm.find('.search-form .item-value .js-select').each(function () {
			if ($(this).hasClass('select2-hidden-accessible')) {
				$(this).jsSelect('destroy');
			}
		});
		searchForm.find('.btn-add').unbind();
		searchForm.find('.btn-remove').unbind();
		searchForm.find('.filter-type').unbind();
		searchForm.find('.tf-spec-toggle').unbind();
	};

	var validate = function () {
		searchForm.find('.error').remove();

		if (
			searchFormHelper.getSearchFormValues().length === 0 &&
			!searchForm.find('.search-form').data('allow-empty-form')
		) {
			$('<p class="error">' + searchForm.find('.search-form').data('empty-message') + '</p>').insertAfter(
				searchForm.find('.search-form-item:first')
			);

			return searchForm.find('.error').length === 0;
		}

		searchForm.find('div[data-filter-date]').each((index, element) => {
			var $element = $(element);
			var startedSinceInput = $element.find('input[data-filter-date-since]');
			var startedUntilInput = $element.find('input[data-filter-date-until]');
			var startedSince = startedSinceInput.val();
			var startedUntil = startedUntilInput.val();

			if (startedSince && !Date.parse(startedSince)) {
				$('<p class="error">' + searchForm.find('.search-form').data('invalid-date-since') + '</p>').insertAfter(
					startedSinceInput.closest('.search-form-item')
				);
			} else if (startedUntil && !Date.parse(startedUntil)) {
				$('<p class="error">' + searchForm.find('.search-form').data('invalid-date-until') + '</p>').insertAfter(
					startedSinceInput.closest('.search-form-item')
				);
			} else if (startedSince && startedUntil && Date.parse(startedSince) > Date.parse(startedUntil)) {
				$('<p class="error">' + searchForm.find('.search-form').data('dates-mismatch') + '</p>').insertAfter(
					startedSinceInput.closest('.search-form-item')
				);
			}
		});

		return searchForm.find('.error').length === 0;
	};

	var addSearchFormItem = function () {
		var notUsedFilters = getNotUsedFilters();

		if (notUsedFilters.length === 0) {
			return;
		}

		var filterType = notUsedFilters[0];
		var searchFormItems = searchForm.find('.search-form-items');
		var searchFormItem = searchFormItems.find('.search-form-item:last').clone();
		searchFormItems.append(searchFormItem);

		searchFormItem.find('.filter-type').val(filterType);
		createFilterInput(searchFormItem);
		searchFormItem.find('.item-value input').val('');

		attachHandlers(searchFormItem);
		showFormTools();
		invalidateFilterOptions();

		return false;
	};

	var removeSearchFormItem = function () {
		if (searchForm.find('.search-form-item').length <= 1) {
			return;
		}

		$(this).closest('.search-form-item').remove();
		showFormTools();
		invalidateFilterOptions();
	};

	var attachHandlers = function (container) {
		container.find('.btn-add').click(addSearchFormItem);
		container.find('.btn-remove').click(removeSearchFormItem);
		container.find('.filter-type').change(function () {
			createFilterInput($(this).closest('.search-form-item'));
			invalidateFilterOptions();
			showHideIndicationLabelingIncompleteWarning();
		});
		container.find('.tf-spec-toggle').click(function () {
			$(this).toggleClass('collapsed');
			$('.header-product-settings-content-act').toggleClass('collapsed');
		});
	};

	var showFormTools = function () {
		searchForm.find('.item-add').hide();

		if (getNotUsedFilters().length > 0) {
			searchForm.find('.item-add:last').show();
		}

		if (searchForm.find('.search-form-item').length > 1) {
			searchForm.find('.item-remove').show();
			searchForm.find('.div-operator').show();
			searchForm.find('.operator-h3').show();
		} else {
			searchForm.find('.item-remove').hide();
			searchForm.find('.div-operator').hide();
			searchForm.find('.operator-h3').hide();
		}

		showHideIndicationLabelingIncompleteWarning();
	};

	var showHideIndicationLabelingIncompleteWarning = function () {
		if (searchForm.find('.filter-type option[value="filter-mesh-illness"]:selected').length > 0) {
			$('#indicationLabelingIncompleteWarning').show();
		} else {
			$('#indicationLabelingIncompleteWarning').hide();
		}
	};

	var invalidateFilterOptions = function () {
		var notUsedFilters = getNotUsedFilters();
		searchForm
			.find('.item-type option')
			.prop('disabled', false)
			.each(function () {
				var value = $(this).attr('value');
				$(this).prop('disabled', notUsedFilters.indexOf(value) < 0 && value !== $(this).parent().val());
			});
	};

	var getNotUsedFilters = function () {
		return getAvailableFilters()
			.filter(function () {
				return (
					searchForm.find('.item-value [name="' + this + '"]').length === 0 &&
					searchForm.find('.item-value [data-filter="' + this + '"]').length === 0
				);
			})
			.get();
	};

	var getAvailableFilters = function () {
		return searchForm.find('.filter-type:first option').map(function () {
			return $(this).attr('value');
		});
	};

	var createFilterInput = function (searchFormItem) {
		var filterType = searchFormItem.find('.filter-type').val();
		var inputTemplate = searchForm.find('.item-value-templates [data-filter="' + filterType + '"]');

		if (inputTemplate.length > 0) {
			applyFilterTemplate(searchFormItem, inputTemplate);
			initDatePicker(searchFormItem);
			initSelect(searchFormItem);

			return;
		}

		inputTemplate = searchForm.find('.item-value-templates [data-filter="filter-other"]');
		applyFilterTemplate(searchFormItem, inputTemplate);
		searchFormItem.find('.item-value').find('input, select').attr('name', filterType);
	};

	var initDatePicker = function (searchFormItem) {
		searchFormItem
			.find('input[data-filter-date-since]')
			.rangeDatepicker(searchFormItem.find('input[data-filter-date-until]'));
	};

	var initSelect = function (searchFormItem) {
		searchFormItem.find('.js-select').each(function () {
			$(this).parent().find('input[type=text]').val('').hide();
			$(this).prop('disabled', false).show();

			if ($(this).is(':visible')) {
				$(this).jsSelect();
			}
		});
	};

	var applyFilterTemplate = function (searchFormItem, inputTemplate) {
		if (searchFormItem.find('.item-value [data-filter="' + inputTemplate.data('filter') + '"]').length === 0) {
			searchFormItem.find('.item-value').html(inputTemplate.clone());
		}
	};

	$.fn.searchForm = function (action) {
		searchForm = this;

		if (action === 'destroy') {
			destroy();
		} else {
			init();
		}

		return this;
	};
})(jQuery);

/**
 * Search form helper.
 */
var searchFormHelper = (function ($) {
	var getSearchFormValues = function () {
		var values = [];

		$('.search-form:first')
			.find('.item-value input, .item-value select')
			.each(function () {
				var inputValues = $.type($(this).val()) === 'string' ? [$(this).val()] : $(this).val();

				for (var i = 0; i < inputValues.length; i++) {
					if (inputValues[i].trim() !== '') {
						values.push({
							name: $(this).attr('name'),
							value: inputValues[i],
						});
					}
				}
			});

		return values;
	};

	var getTFValues = function () {
		var values = [];

		$('.search-form:first')
			.find('input[name=tf]:checked')
			.each(function () {
				var inputValues = $.type($(this).val()) === 'string' ? [$(this).val()] : $(this).val();

				for (var i = 0; i < inputValues.length; i++) {
					if (inputValues[i].trim() !== '') {
						values.push({
							name: $(this).attr('name'),
							value: $(this).attr('value'),
						});
					}
				}
			});

		return values;
	};

	var getOperatorValue = function () {
		return $('.search-form:first input[name=operator]:checked').val();
	};

	var isWithProductBrothers = function () {
		return $('.search-form:first input[name=with-product-brothers]:checked').length > 0;
	};

	var getOrderValue = function () {
		return getURLParam('order');
	};

	var getSortDirectionValue = function () {
		return getURLParam('sort-direction');
	};

	var getViewValue = function () {
		return $('.search-form:first input[name=view]:checked').val();
	};

	return {
		getSearchFormValues: getSearchFormValues,
		getTFValues: getTFValues,
		getOperatorValue: getOperatorValue,
		isWithProductBrothers: isWithProductBrothers,
		getOrderValue: getOrderValue,
		getSortDirectionValue: getSortDirectionValue,
		getViewValue: getViewValue,
	};
})(jQuery);

export { searchFormHelper };
